module.exports = __webpack_public_path__ + "img/bch-logo.b75c47eb.svg";